import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import ValentineSiteTakeoverBackground from 'takeovers/valentineTakeover/components/ValentineSiteTakeoverBackground'

const valentineTakeoverConfig: App.SiteTakeoverConfig = {
  id: 'valentine',
  imageId: 'gidua9dchhephstwu3jp',
  primaryColour: '#F84916',
  palette: 'default',
  offerTypes: new Set(['hotel']),
  verticals: new Set(['home', 'hotel']),
  heroSection: {
    title: <FormattedMessage
      id="N7gjr2j56U"
      defaultMessage="Happy Valentine's Day"
      description="Title for Valentine's Day promotional campaign"
    />,
    subtitle: <FormattedMessage
      id="RwMgHS4koD"
      defaultMessage="Use code <bold>LOVEISINTHEAIR</bold> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025"
      description="Subtitle for Valentine's Day campaign with promo code"
      values={{ bold: (chunks) => <b>{chunks}</b> }}
    />,
    verticals: new Set(['home']),
  },
  backgroundElement: ValentineSiteTakeoverBackground,
  offerPage: {
    bannerContent: <FormattedMessage
      id="O9QXzcbJpO"
      defaultMessage="Use code <bold>LOVEISINTHEAIR</bold> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025"
      description="Offer page banner for Valentine's Day campaign with promo code"
      values={{ bold: (chunks) => <b>{chunks}</b> }}
    />,
  },
  siteWide: {
    banner: {
      description: <FormattedMessage
        id="/p4oz37P2K"
        defaultMessage="Use code <bold>LOVEISINTHEAIR</bold> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025"
        description="Site-wide banner for Valentine's Day campaign with promo code"
        values={{ bold: (chunks) => <b>{chunks}</b> }}
      />,
    },
  },
  searchPage: {
    bannerContent: <VerticalSpacer gap={2}>
      <Heading variant="heading2"><FormattedMessage
        id="X5yKyUWQnq"
        defaultMessage="Happy Valentine's Day"
        description="Heading for Valentine's Day campaign on search page"
      />
      </Heading>
      <BodyText variant="large"><FormattedMessage
        id="PHRUmLU0Ji"
        defaultMessage="Use code <bold>LOVEISINTHEAIR</bold> at checkout for 5% extra love on your hotel bookings. Valid 12-14th Feb 2025"
        description="Search page banner for Valentine's Day campaign with promo code"
        values={{ bold: (chunks) => <b>{chunks}</b> }}
      />
      </BodyText>
    </VerticalSpacer>,
  },

}

export default valentineTakeoverConfig
